export class SetUserToken {
  static readonly type = '[User] Set user token';
  constructor(public userToken: string) {}
}

export class SetUserInformations {
  static readonly type = '[User] Set user data';
  constructor(public userData: any) {}
}
